module.exports = __webpack_public_path__ + "img/extended.588af5f7.png";